import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "popup",
  "cy-data": "popup"
}
const _hoisted_2 = { class: "popup__content-view fs-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    name: "fade",
    mode: "out-in"
  }, {
    default: _withCtx(() => [
      (_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("button", {
              class: "popup__button",
              type: "button",
              "cy-data": "popup-button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.buttonClicked && _ctx.buttonClicked(...args)))
            }),
            _createElementVNode("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}